import ContactItem from '../shared/ContactItem'
import SectionCard from '../shared/SectionCard'
import { CRRender } from '@/components/crRender'

const ContactInfo = ({ requestDetails }) => {
    return (
        <div>
            <SectionCard icon="mdi:phone" titleKey="contact-info">
                <div className="request-data contact-information-list">
                    <ContactItem
                        icon="mdi:phone"
                        labelKey="Phone"
                        value={requestDetails?.phoneNumber}
                    />

                    <ContactItem
                        icon="mdi:email"
                        labelKey="Email"
                        value={requestDetails?.email}
                        isLink
                        linkType="email"
                    />

                    <CRRender isRender={!!requestDetails?.websiteUrl}>
                        <ContactItem
                            icon="mdi:web"
                            labelKey="websiteUrl"
                            value={requestDetails?.websiteUrl}
                            isLink
                            linkType="url"
                        />
                    </CRRender>
                </div>
            </SectionCard>
        </div>
    )
}

export default ContactInfo

